import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=7ad189a8&scoped=true&"
import script from "./TaskRow.vue?vue&type=script&lang=js&"
export * from "./TaskRow.vue?vue&type=script&lang=js&"
import style0 from "./TaskRow.vue?vue&type=style&index=0&id=7ad189a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad189a8",
  null
  
)

export default component.exports